var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57732 1.00005L14.928 12.0001C15.0471 12.2063 15.0471 12.4604 14.928 12.6667C14.8089 12.873 14.5888 13 14.3506 13.0001H1.64932C1.41114 13 1.19106 12.873 1.07198 12.6667C0.952894 12.4604 0.952895 12.2063 1.07198 12.0001L7.42265 1.00005C7.54174 0.793801 7.76182 0.666748 7.99998 0.666748C8.23815 0.666748 8.45822 0.793801 8.57732 1.00005ZM2.80398 11.6667H13.196L7.99998 2.66671L2.80398 11.6667ZM7.33331 9.66671H8.66664V11H7.33331V9.66671ZM7.33331 5.00005H8.66664V8.33338H7.33331V5.00005Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation);
export default __webpack_public_path__ + "static/media/triangle-exclamation.4b67ad368d282aa217ea182b44303eea.svg";
export { ForwardRef as ReactComponent };